import styles from "./BookingSlotsCard.module.css";

export interface BookingSlot {
    time: string;
    end_time: string;
    date: string;
    day: string;
}

interface BookingSlotsCardProps {
    packageName: string;
    slots: BookingSlot[];
    onSelectSlot?: (slot: BookingSlot) => void;
}

/** Group slots by date for visual grouping. */
const groupByDate = (slots: BookingSlot[]) => {
    const groups: Record<string, BookingSlot[]> = {};
    for (const slot of slots) {
        const key = `${slot.day}, ${slot.date}`;
        if (!groups[key]) groups[key] = [];
        groups[key].push(slot);
    }
    return groups;
};

export const BookingSlotsCard = ({ packageName, slots, onSelectSlot }: BookingSlotsCardProps) => {
    if (!slots || slots.length === 0) {
        return (
            <div className={styles.container}>
                <div className={styles.header}>Available Slots for {packageName}</div>
                <div className={styles.noSlots}>No available slots found. Please try different dates.</div>
            </div>
        );
    }

    const grouped = groupByDate(slots);

    return (
        <div className={styles.container}>
            <div className={styles.header}>Available Slots for {packageName}</div>
            {Object.entries(grouped).map(([dateLabel, dateSlots]) => (
                <div key={dateLabel} className={styles.dateGroup}>
                    <div className={styles.dateLabel}>{dateLabel}</div>
                    <div className={styles.slotsGrid}>
                        {dateSlots.map((slot) => (
                            <button
                                key={`${slot.date}-${slot.time}`}
                                className={styles.slotButton}
                                onClick={() => onSelectSlot?.(slot)}
                            >
                                <span className={styles.slotTime}>{slot.time}</span>
                            </button>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};
